import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



import { asyncRoutes, constRoutes } from "@/router"; //静态路由也需引入，目的是为了拼接生成的有权限的动态路由，生成完成路由表

//根据路由表的roles字段+权限列表判断有无权限的方法 返回bool值。
function hasPermission(roles, route) {
  let role = JSON.parse(roles)
  if (route.meta && route.meta.roles) {
    return role.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

//根据后端传回的权限列表roles+hasPermission。
export function filterAsyncRoutes(routes, roles) {
  const res = [];
  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      //有权限才对其嵌套路由进行递归
      if (tmp.children) {
        //递归方式对嵌套路由过滤
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
  // menus:[],
  // authorizes:[]
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes; //需要添加的动态路由表，路由守卫处使用
    state.routes = constRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, roles) {
    // let { role, roleslist } = roles    //roleslist为后端返回的权限列表 为实现修改权限 故不能简单根据role判断
    return new Promise((resolve) => {
      let accessedRoutes;
      // if (role.includes("admin")) {//管理员则不需按权限列表过滤
      //   accessedRoutes = asyncRoutes || [];
      // } else {
      //   accessedRoutes = filterAsyncRoutes(asyncRoutes, roleslist); //根据权限列表对动态路由进行过滤
      // }
      accessedRoutes = asyncRoutes || [];
      commit("SET_ROUTES", accessedRoutes); //仓库保存
      resolve(accessedRoutes);
    });
  },
};

// export default {
//   namespaced: true,
//   state,
//   mutations,
//   actions,
// };

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {
  }
})
